import { useTranslation } from 'react-i18next';

import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogTitle,
    AlertDialogTrigger,
} from '@codes/ui-kit/components/ui/alert-dialog';
interface DeleteCardDialogProps {
    onDelete: () => void;
    trigger: React.ReactNode;
}

export const DeleteCardDialog = ({ onDelete, trigger }: DeleteCardDialogProps) => {
    const { t } = useTranslation();

    return (
        <AlertDialog>
            <AlertDialogTrigger asChild>{trigger}</AlertDialogTrigger>
            <AlertDialogContent aria-describedby={undefined}>
                <AlertDialogTitle>{t('myPage.confirmCardDeletion')}</AlertDialogTitle>
                <AlertDialogFooter>
                    <AlertDialogCancel>{t('myPage.cancel')}</AlertDialogCancel>
                    <AlertDialogAction onClick={onDelete}>{t('myPage.deleteCardConfirm')}</AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};
